import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { PageHeader, PageBody, StatusBadge, EmptyState, formatMoney } from "../components/Shared";

export default function SupplierDetail() {
  const { id } = useParams();
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/suppliers/${id}`).then((r) => setD(r.data)); }, [id]);
  if (!d) return <PageBody>Loading…</PageBody>;
  const { supplier, purchase_items } = d;

  // group items: this supplier acts as primary vs sub
  const asPrimary = purchase_items.filter((r) => r.item.supplier_id === id);
  const asSub = purchase_items.filter((r) => r.item.sub_supplier_id === id && r.item.supplier_id !== id);

  const Table = ({ rows, role }) => (
    <div className="bg-white border border-slate-300 mb-8">
      <div className="px-3 py-2 bg-slate-50 border-b border-slate-300 flex items-center justify-between">
        <div className="label-caps">{role}</div>
        <div className="label-caps">{rows.length} items</div>
      </div>
      <table className="w-full text-sm">
        <thead className="border-b border-slate-200"><tr className="text-left">
          <th className="py-2 px-3 label-caps">Order</th>
          <th className="py-2 px-3 label-caps">Part #</th>
          <th className="py-2 px-3 label-caps">Mfr</th>
          <th className="py-2 px-3 label-caps text-right">Qty</th>
          <th className="py-2 px-3 label-caps text-right">Unit</th>
          <th className="py-2 px-3 label-caps">Status</th>
        </tr></thead>
        <tbody>
          {rows.map((r) => (
            <tr key={`${r.order_id}-${r.item.id}`} className="border-b border-slate-200 hover:bg-slate-50">
              <td className="py-2 px-3 font-mono"><Link to={`/orders/${r.order_id}`} className="text-blue-700 hover:text-blue-900">{r.order_number}</Link></td>
              <td className="py-2 px-3 font-mono">{r.item.part_number}</td>
              <td className="py-2 px-3">{r.item.manufacturer || "-"}</td>
              <td className="py-2 px-3 font-mono text-right">{r.item.quantity}</td>
              <td className="py-2 px-3 font-mono text-right">{formatMoney(r.item.unit_price, r.item.currency)}</td>
              <td className="py-2 px-3"><StatusBadge status={r.item.status} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <>
      <PageHeader title={supplier.name} subtitle={<Link to="/suppliers" className="hover:text-blue-700">Suppliers</Link>} testid="supplier-detail-title" />
      <PageBody>
        <div className="grid md:grid-cols-4 gap-0 border border-slate-300 bg-white mb-6">
          {[["Contact", supplier.contact_person], ["Email", supplier.email], ["Phone", supplier.phone], ["Items assigned", purchase_items.length]].map(([k, v], i, arr) => (
            <div key={k} className={`p-5 ${i < arr.length - 1 ? "border-r border-slate-200" : ""}`}>
              <div className="label-caps">{k}</div><div className="mt-2 font-mono text-slate-900">{v || "-"}</div>
            </div>
          ))}
        </div>

        {purchase_items.length === 0 ? <EmptyState title="No items assigned" hint="Assign this supplier to order items to track purchases." /> :
          <>
            {asPrimary.length > 0 && <Table rows={asPrimary} role="As primary supplier" />}
            {asSub.length > 0 && <Table rows={asSub} role="As sub-supplier" />}
          </>
        }
      </PageBody>
    </>
  );
}
